import { Message } from 'element-ui'

const vCopy = {
  bind(el, { value }) {
    el.$value = value

    el.handler = () => {
      if (!el.$value) {
        Message.warning('无复制内容')
        return
      }

      const textarea = document.createElement('textarea')
      textarea.readOnly = 'readonly'
      textarea.value = el.$value
      document.body.appendChild(textarea)
      textarea.select()
      textarea.setSelectionRange(0, textarea.value.length)
      const result = document.execCommand('Copy')
      if (result) Message.success('复制成功')
      document.body.removeChild(textarea)
    }

    el.addEventListener('click', el.handler)
  },

  componentUpdated(el, { value }) {
    el.$value = value
  },

  unbind(el) {
    el.removeEventListener('click', el.handler)
  }
}

export default vCopy
